import { render } from "./CampaignPreview.vue?vue&type=template&id=6d47acc2&scoped=true"
import script from "./CampaignPreview.vue?vue&type=script&lang=js"
export * from "./CampaignPreview.vue?vue&type=script&lang=js"

import "./CampaignPreview.vue?vue&type=style&index=0&id=6d47acc2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d47acc2"]])

export default __exports__